import * as React from 'react';
import {connect} from 'react-redux';
import {Tab, Tabs, withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {infobankStyle} from './notes.style';
import SharedNotes from '@components/sharednotes/SharedNotesView';
import {ISharedNote} from '@app-types/websocket/sharedinfo.types';
import {IFlowPost} from '@app-types/websocket/imageflow.types';
import { ITodo, TODO_TYPE } from '@app-types/websocket/todo.types';
import TodoList from '@components/todo/TodoList';
import TodoButton from '@components/todo/TodoButton';
import { RouteComponentProps } from 'react-router-dom';
import NextHandover from '@components/next-handover/NextHandover';
import { ISchedule } from '@app-types/websocket/schedule.types';
import BottomBar from '@components/calendar2/fab/BottomBar';
import { getSelectedFamilyResource } from '@services/user/user.utils';
import { getInitialPane, PaneIndex, toPaneIndex } from '@helpers/horizontalPaneState';
import * as UiActions from '@services/ui/ui.actions';
import {IEvent} from '@app-types/websocket/event.types';
import {getCalendarTodoCount} from '@components/todo/calendarTodoItems';
import {useCalendarTodoDate} from '@components/todo/useCalendarTodoDate';
import {usePackingBadgeCount} from '@components/next-handover/packingList';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends RouteComponentProps, WithStyles<typeof infobankStyle> {
  myAccountId: number;
  unseenNotes: number;
  unseenTodos: number;
  unseenPacking: number;
  todos: ITodo[];
  schedules: ISchedule[];
  calendars: number[] | undefined;
  calendarEvents: IEvent[];
  isTogether:boolean;
  lastNotesPane: PaneIndex;
  setLastNotesPane: (pane: PaneIndex) => void;
}

interface IState {
  scrollBullet: PaneIndex;
  scrollEndTime: number;
  hideFab:boolean;
}

class NotesContainer extends React.Component<IProps, IState> {
  private timer:NodeJS.Timeout|null = null;


  
  constructor(props: IProps) {
    super(props);

    this.state = {
      scrollBullet: getInitialPane(props.location && props.location.pathname, "/app/notes", props.lastNotesPane),
      scrollEndTime: 0,
      hideFab: false,
    };

  }

  public componentDidMount() {
    this.props.setLastNotesPane(this.state.scrollBullet);
    this.scrollDirect(this.state.scrollBullet);
  }

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const pane = getInitialPane(this.props.location && this.props.location.pathname, "/app/notes", this.props.lastNotesPane);
      this.props.setLastNotesPane(pane);
      if (pane !== this.state.scrollBullet) {
        this.setState({scrollBullet: pane, scrollEndTime: Date.now()});
        this.scrollDirect(pane);
      }
    }
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }


  public render() {
    const {classes} = this.props;

    const firstTab = this.props.isTogether
      ?<Tab
        label={<div style={{display: 'flex', flexDirection: 'row'}}>
          <div>{tn.lang.calWeekPlanning}</div>
          <div 
            className={this.props.classes.badge}  
            style={{display:'none'}}>
            {0}
          </div>
        </div>}
      />
      :<Tab
        label={<div style={{display: 'flex', flexDirection: 'row'}}>
          <div>{tn.lang.calPackingList}</div>
          <div 
            className={this.props.classes.badge}  
            style={{display:(this.props.unseenPacking>0?undefined:'none')}}>
            {this.props.unseenPacking}
          </div>
        </div>}
      />

      const pageOne = this.props.isTogether
      ?<div>{tn.lang.implement}</div>
      :<NextHandover hide={this.state.scrollBullet !== 0 || this.state.hideFab}/>

    return (<div className={classes.container}>
        <div className={classes.tabs}>
          <div className={this.props.classes.containerTop}><div className={this.props.classes.containerCorners} /></div>
          <Tabs
            value={this.state.scrollBullet}
            onChange={(event, value) => {
            const pane = toPaneIndex(value);
            if (pane !== undefined) {
              this.storePane(pane);
              this.scroll(pane);
            }
          }}
            classes={{
              indicator: classes.tabsIndicator
            }}
          >
            {firstTab}
            <Tab
              label={
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <div>{tn.lang.sharedSharedNotes}</div>
                  <div className={classes.badge} style={{display: (this.props.unseenNotes > 0 ? undefined : 'none')}}>
                    {this.props.unseenNotes}
                  </div>
                </div>}
            />
            <Tab
              label={<div style={{display: 'flex', flexDirection: 'row'}}>
                <div>{tn.lang.todoList}</div>
                <div 
                  className={this.props.classes.badge}  
                  style={{display:(this.props.unseenTodos>0?undefined:'none')}}>
                  {this.props.unseenTodos}
                </div>
              </div>}
            />
          </Tabs>
        </div>
        <div id="notesview"
          className={classes.horizontalController}
          onScroll={() => {
              if (this.timer) {
                clearTimeout(this.timer);
              }
              
              this.timer = setTimeout(() => {this.checkScrollPos();}, 200);
        }}>

          <div className={classes.infobankColumn} style={this.props.isTogether ? {padding: '12px 20px 150px 20px'} : undefined}
            onScroll={() => {
              if (this.timer) {
                clearTimeout(this.timer);
              }
             
             this.timer = setTimeout(() => this.checkScrollPos(), 200);
           }}>
            {pageOne}
          </div>


          <div className={classes.infobankColumn} style={{overflow: 'hidden'}}>
            <SharedNotes noteTypes={"NOTES"} rootClass={classes.infobankColumn} hideFAB={this.state.scrollBullet !== 1 ||this.state.hideFab}/>
          </div>
          <div className={`${classes.infobankColumn} ${classes.todoColumn}`}
            onScroll={() => {
              if (this.timer) {
                clearTimeout(this.timer);
              }
             
             this.timer = setTimeout(() => this.checkScrollPos(), 200);
           }}>
            <TodoButton style={{position:'absolute'}} hide={this.state.hideFab || this.state.scrollBullet !== 2}/>
            <TodoList
              showHelper={true}
              hideHeader={true}
              hide = {this.state.scrollBullet !== 2}
              scrollTime={this.state.scrollEndTime}
              myAccountId={this.props.myAccountId}
            />
          </div>
        </div>
        <BottomBar 
          hidden={false}
          displaySubmenyCallback={(hideFAB:boolean) => {this.setState({hideFab:hideFAB})}}
        />
      </div>
    );
  }

  private scroll(pane: PaneIndex) {
    const elmnt = document.getElementById("notesview");
    if (elmnt !== null) {
      elmnt.scroll({top: 0, left: ((elmnt.scrollWidth * pane) / 3), behavior: 'smooth'});
    }
  }

  private scrollDirect(pane: PaneIndex) {
    const elmnt = document.getElementById("notesview");
    if (elmnt !== null) {
      elmnt.scrollTop = 0;
      elmnt.scrollLeft = (elmnt.scrollWidth * pane) / 3;
    }
  }

  private checkScrollPos() {
    const elmnt = document.getElementById("notesview");
    if (elmnt !== null) {
      // console.log(elmnt.scrollLeft+"/"+elmnt.scrollWidth);
      if (elmnt.scrollLeft <= elmnt.scrollWidth / 6) {
        this.storePane(0);
      } else if (elmnt.scrollLeft <= (elmnt.scrollWidth * 3) / 6) {
        this.storePane(1);
      } else if (elmnt.scrollLeft <= (elmnt.scrollWidth * 5) / 6) {
        this.storePane(2);
      }
    }
  }

  private storePane(pane: PaneIndex) {
    this.props.setLastNotesPane(pane);
    this.setState({scrollBullet: pane, scrollEndTime: Date.now()});
  }

}



const NO_SCHEDULES: ISchedule[] = [];

const NotesWithCalendarTodos = (props: IProps) => {
  const now = useCalendarTodoDate();
  const calendarCount = getCalendarTodoCount(props.calendarEvents, props.myAccountId, now);
  const unseenPacking = usePackingBadgeCount(props.todos, props.schedules, props.calendars, props.myAccountId);
  return <NotesContainer {...props} unseenTodos={props.unseenTodos + calendarCount} unseenPacking={unseenPacking} />;
};

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const sharedStuff: ISharedNote[] = state.notes.sharedNotes?state.notes.sharedNotes:[];
  const posts: IFlowPost[] = state.posts.posts;
  const todos: ITodo[] = state.todo.todos?state.todo.todos:[];
  const unHandled = todos.filter((todo: ITodo) => todo.type === TODO_TYPE.NORMAL)
    .filter((todo: ITodo) => todo.completedBy === undefined);
  const unSeen = unHandled.filter((todo: ITodo) => ((todo.seen && !todo.seen.includes(userId)) 
    || (todo.completedBy === undefined && todo.assigned && todo.assigned.includes(userId))));

  let unseenNotes = 0;

  for (const note of sharedStuff) {
    if (note.accountName === undefined) {
      if (note.seenBy.indexOf(userId) === -1) {
        unseenNotes++;
      }
    }
  }

  let unseenPosts = 0;
  for (const post of posts) {
    if (post.seen.indexOf(userId) === -1) {
      unseenPosts++;
    }
  }

  let isTogether:boolean = false;
  const myFam = getSelectedFamilyResource(state.user?.session);
  if (myFam !== undefined) {
      isTogether = myFam.familyType === "TOGETHER";
  }

  const lastNotesPane = toPaneIndex(state.ui && state.ui.lastNotesPane);

  return {
    isTogether,
    myAccountId:userId,
    unseenNotes,
    unseenTodos:unSeen.length,
    calendarEvents: state.event?.events || [],
    todos,
    schedules: state.schedule && state.schedule.schedules ? state.schedule.schedules : NO_SCHEDULES,
    calendars: state.user.calendarSettings ? state.user.calendarSettings.calendars : undefined,
    lastNotesPane: lastNotesPane !== undefined ? lastNotesPane : 0,
  };
}

const mapDispatchToProps = {
  setLastNotesPane: UiActions.setLastNotesPane,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(infobankStyle)(NotesWithCalendarTodos));



// WEBPACK FOOTER //
// ./src/containers/notes/notes.container.tsx